module.exports = __webpack_public_path__ + "static/media/porto-seguro.0dae24e6.png";